export default "__VITE_ASSET__F85JyMK7__"